import { CountResponse } from '@interfaces/common.interface';
import {
  CountMedicalSpecialitiesRequestParams,
  CreateMedicalSpecialityRequest,
  GetMedicalSpecialitiesRequestParams,
  MedicalSpeciality,
  UpdateMedicalSpecialityRequest,
} from '@interfaces/medicalSpecialities.interface';

import api from './';

export const {
  useCountMedicalSpecialitiesQuery,
  useGetManyMedicalSpecialitiesQuery,
  useCreateMedicalSpecialityMutation,
  useUpdateMedicalSpecialityMutation,
  useDeleteMedicalSpecialityMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    countMedicalSpecialities: build.query<
      CountResponse,
      CountMedicalSpecialitiesRequestParams
    >({
      query: (params) => ({ url: 'medical-specialities/count', params }),
      providesTags: ['medicalSpecialities'],
    }),
    getManyMedicalSpecialities: build.query<
      MedicalSpeciality[],
      GetMedicalSpecialitiesRequestParams
    >({
      query: (params) => ({ url: 'medical-specialities', params }),
      providesTags: ['medicalSpecialities'],
    }),
    createMedicalSpeciality: build.mutation<
      MedicalSpeciality,
      CreateMedicalSpecialityRequest
    >({
      query: (body) => ({
        url: 'medical-specialities',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['medicalSpecialities'],
    }),
    updateMedicalSpeciality: build.mutation<
      MedicalSpeciality,
      UpdateMedicalSpecialityRequest
    >({
      query: ({ id, body }) => ({
        url: `medical-specialities/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['medicalSpecialities'],
    }),
    deleteMedicalSpeciality: build.mutation<MedicalSpeciality, string>({
      query: (id) => ({
        url: `medical-specialities/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['medicalSpecialities'],
    }),
  }),
});
